<template>
  <div class="placeholder">
    <div class="placeholder-icon">
      <span class="icon huge-icon">
        <i class="fa fa-wrapper fa-file-code"></i>
      </span>
    </div>
    <h6 class="placeholder-title">{{ title }}</h6>
    <div class="placeholder-subtitle">{{ message }}</div>
  </div>
</template>
<style></style>
<script>
module.exports = {
  name: "no-results-found",
  props: ["title", "message"]
};
</script>
